module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/store_images/5_11fcf02eac6cef15319808a4104adcdb.png";